import CustomSwitch, { ICustomSwitchProps } from '@components/std-components/Switch'
import { useObserver } from 'mobx-react-lite'
import React from 'react'
import { useTranslation } from 'react-i18next'

export default function QuantitySwitch(props: ICustomSwitchProps): JSX.Element {
  return useObserver(function useHook() {
    const { t } = useTranslation()
    return (
      <CustomSwitch
        labelLeft={t('common.label.quantity', 'Quantity')}
        labelRight={t('common.label.value', 'Value')}
        {...props}
      />
    )
  })
}
